/** Note types used by the doors notes API: 0 = text, 1 = photo, 2 = voice. */
export type DoorNoteType = 0 | 1 | 2;

export const DOOR_NOTE_TYPE = { text: 0, photo: 1, voice: 2 } as const satisfies Record<string, DoorNoteType>;

/** A note attached to a door (legacy `doors/notes` API). */
export interface DoorNote {
  Id?: string;
  Timestamp?: string;
  MbeUserId?: string;
  CompanyId?: string;
  ProjectId?: string;
  DoorId?: string;
  DoorNo?: string;
  NoteType?: DoorNoteType;
  Photo?: string;
  Text?: string;
}
